module.exports = __webpack_public_path__ + "static/media/9.a658ea1a.png";